export const carouselItems = [
  {
    id: 1,
    title: '暑期档热映精选',
    subtitle: '2026年夏季必看大片合集',
    description: '汇集今夏最受期待的院线大片与平台首发新片，涵盖动作、科幻、喜剧等热门类型，让你一次看过瘾。',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20with%20warm%20golden%20lighting%2C%20film%20reel%20elements%2C%20summer%20blockbuster%20vibe%2C%20dark%20theater%20background%20with%20soft%20glow%2C%20professional%20cinematography%20style%2C%20rich%20contrast%2C%20movie%20poster%20aesthetic&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高分经典重温计划',
    subtitle: '豆瓣8.5+口碑神作回顾',
    description: '精选近百部豆瓣高分经典影片，从文艺片到类型片，每一部都经得起时间考验，重温那些感动过我们的故事。',
    tag: '口碑佳作',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20classic%20film%20aesthetic%20with%20warm%20sepia%20tones%2C%20old%20movie%20posters%20on%20wall%2C%20film%20projector%20with%20soft%20light%20beam%2C%20nostalgic%20cinema%20atmosphere%2C%20golden%20hour%20lighting%2C%20artistic%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '华语新片速递专区',
    subtitle: '第一时间更新国产佳作',
    description: '持续追踪华语电影最新动态，院线新片、网络电影同步上线，支持高清画质流畅播放，不错过任何一部好片。',
    tag: '最新上线',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20cinema%20scene%20with%20warm%20dramatic%20lighting%2C%20film%20clapperboard%20on%20set%2C%20elegant%20dark%20red%20curtains%2C%20contemporary%20movie%20production%20style%2C%20cinematic%20color%20grading%2C%20soft%20spotlight%20effect&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '韩剧精选追更日历',
    subtitle: '热播韩剧一网打尽',
    description: '整理当季最热韩剧更新日程，从浪漫爱情到悬疑烧脑，中文字幕同步更新，再也不用到处找资源。',
    tag: '剧集专区',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20soft%20pastel%20lighting%2C%20cherry%20blossom%20elements%2C%20warm%20cozy%20atmosphere%2C%20cinematic%20composition%2C%20gentle%20bokeh%20background%2C%20emotional%20storytelling%20vibe&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '纪录片的真实力量',
    subtitle: '用镜头探索世界真相',
    description: '精选国内外优秀纪录片，涵盖自然、人文、历史、科技等领域，足不出户领略大千世界的精彩与深度。',
    tag: '深度内容',
    image: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20cinematic%20scene%20with%20dramatic%20landscape%2C%20golden%20sunset%20light%20over%20mountains%2C%20aerial%20photography%20style%2C%20rich%20earthy%20warm%20tones%2C%20professional%20wildlife%20footage%20aesthetic%2C%20breathtaking%20vista&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    id: 6,
    title: '动漫狂欢季',
    subtitle: '经典番剧与热门新番',
    description: '丰富动漫资源库持续扩充中，日漫、国漫、剧场版一应俱全，高清画质还原每一个精彩瞬间。',
    tag: '动漫天地',
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20cinematic%20scene%20with%20vibrant%20colors%2C%20dynamic%20composition%2C%20Japanese%20animation%20aesthetic%2C%20cherry%20blossom%20and%20cityscape%20blend%2C%20warm%20sunset%20sky%2C%20dreamy%20atmosphere&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export const comments = [
  {
    id: 1,
    author: '追剧小王子',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20modern%20avatar%20profile%20portrait%2C%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20background%2C%20friendly%20expression&width=80&height=80&seq=avatar-01&orientation=squarish',
    date: '2026-07-28',
    content: '用了春色影视快一年了，画质是真的好，关键是完全免费还没有广告弹窗，良心平台！推荐给了好多朋友。',
    rating: 5,
  },
  {
    id: 2,
    author: '电影迷阿强',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20modern%20avatar%20profile%20portrait%20male%2C%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20background%2C%20casual%20expression&width=80&height=80&seq=avatar-02&orientation=squarish',
    date: '2026-07-26',
    content: '片库真的很大，很多冷门老片都能找到。播放流畅不卡顿，晚上高峰期也很稳定，爱了爱了。',
    rating: 5,
  },
  {
    id: 3,
    author: '深夜观影人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20modern%20avatar%20profile%20portrait%20female%2C%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20background%2C%20gentle%20expression&width=80&height=80&seq=avatar-03&orientation=squarish',
    date: '2026-07-25',
    content: '更新速度超快，新剧刚出这边就有了。字幕质量也不错，翻译准确。就是希望能加个收藏功能就更好了。',
    rating: 4,
  },
  {
    id: 4,
    author: '周末宅家族',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20modern%20avatar%20profile%20portrait%20young%2C%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20background%2C%20happy%20expression&width=80&height=80&seq=avatar-04&orientation=squarish',
    date: '2026-07-23',
    content: '每个周末都在春色影视上刷剧，种类丰富，想看什么类型都有。高清画质在大屏上看特别爽！',
    rating: 5,
  },
  {
    id: 5,
    author: '纪录片爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20modern%20avatar%20profile%20portrait%20adult%2C%20warm%20lighting%2C%20minimalist%20style%2C%20soft%20background%2C%20thoughtful%20expression&width=80&height=80&seq=avatar-05&orientation=squarish',
    date: '2026-07-20',
    content: '纪录片区做得越来越好了，BBC和NHK的经典纪录片都有。画质清晰，中文字幕也很到位，非常满意。',
    rating: 5,
  },
];

export const indexItems = [
  { id: 1, name: '动作片', icon: 'ri-sword-line', count: 2860, color: 'bg-accent-500' },
  { id: 2, name: '喜剧片', icon: 'ri-emotion-laugh-line', count: 1950, color: 'bg-primary-500' },
  { id: 3, name: '爱情片', icon: 'ri-heart-line', count: 1520, color: 'bg-accent-400' },
  { id: 4, name: '科幻片', icon: 'ri-rocket-line', count: 1340, color: 'bg-secondary-500' },
  { id: 5, name: '悬疑片', icon: 'ri-search-eye-line', count: 1180, color: 'bg-primary-400' },
  { id: 6, name: '动画片', icon: 'ri-movie-line', count: 2100, color: 'bg-accent-300' },
  { id: 7, name: '纪录片', icon: 'ri-earth-line', count: 960, color: 'bg-secondary-400' },
];

export const updates = [
  { id: 1, date: '07-31', title: '《星际穿越2》高清版本已上线', type: 'new' },
  { id: 2, date: '07-31', title: '热播韩剧《她的秘密》更新至第10集', type: 'update' },
  { id: 3, date: '07-30', title: '《长安三万里2》独家首发上线', type: 'new' },
  { id: 4, date: '07-30', title: '纪录片专区新增BBC《蓝色星球3》全集', type: 'new' },
  { id: 5, date: '07-29', title: '日漫新番《鬼灭之刃 最终季》同步更新', type: 'update' },
  { id: 6, date: '07-28', title: '平台播放引擎升级，加载速度提升40%', type: 'system' },
  { id: 7, date: '07-28', title: '《流浪地球3》1080P高清版上线', type: 'new' },
  { id: 8, date: '07-27', title: '美剧《权游前传》第二季字幕已同步', type: 'update' },
  { id: 9, date: '07-26', title: '国产悬疑剧《暗夜追踪》全集一次放送', type: 'new' },
];

export const appData = {
  title: '春色影视移动端',
  subtitle: '随时随地，高清观影',
  description: '春色影视移动端完美适配手机和平板，支持离线缓存、画质切换和投屏功能。在地铁上、旅途中也能畅享高清影视体验。',
  features: ['高清流畅播放', '支持离线缓存', '一键投屏电视', '智能续播记忆'],
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20movie%20streaming%20app%20interface%2C%20dark%20theme%20UI%20with%20warm%20accent%20colors%2C%20film%20poster%20thumbnails%2C%20modern%20minimal%20design%2C%20floating%20phone%20on%20clean%20background%2C%20soft%20ambient%20lighting&width=600&height=700&seq=app-showcase&orientation=portrait',
};

export const features = [
  {
    id: 1,
    icon: 'ri-4k-line',
    title: '超清画质',
    description: '支持1080P至4K超清画质，根据网络自动适配最佳分辨率，大屏观影也不模糊。',
  },
  {
    id: 2,
    icon: 'ri-speed-up-line',
    title: '流畅不缓冲',
    description: '全球CDN加速节点覆盖，智能预加载技术确保播放流畅，告别卡顿和缓冲等待。',
  },
  {
    id: 3,
    icon: 'ri-database-2-line',
    title: '海量片库',
    description: '收录超过两万部电影电视剧，涵盖全球热门内容与经典作品，持续扩充更新中。',
  },
  {
    id: 4,
    icon: 'ri-calendar-check-line',
    title: '每日更新',
    description: '编辑团队全天候追踪最新影视资源，新片新剧第一时间上线，追剧无需等待。',
  },
  {
    id: 5,
    icon: 'ri-shield-check-line',
    title: '完全免费',
    description: '无需注册登录，无需付费订阅，所有内容完全免费观看，真正零门槛享受影视盛宴。',
  },
];

export const rankingItems = [
  { rank: 1, title: '流浪地球3', type: '电影', hot: 98500, trend: 'up', tag: '热播' },
  { rank: 2, title: '她的秘密', type: '韩剧', hot: 87200, trend: 'up', tag: '新番' },
  { rank: 3, title: '星际穿越2', type: '电影', hot: 76800, trend: 'up', tag: '热播' },
  { rank: 4, title: '长安三万里2', type: '动画', hot: 65400, trend: 'up', tag: '新片' },
  { rank: 5, title: '暗夜追踪', type: '国产剧', hot: 58900, trend: 'up', tag: '热播' },
  { rank: 6, title: '鬼灭之刃 最终季', type: '日漫', hot: 52100, trend: 'same', tag: '连载' },
  { rank: 7, title: '权游前传 S2', type: '美剧', hot: 46700, trend: 'down', tag: '更新' },
];

export const topics = [
  { id: 1, name: '暑期档推荐', count: '12.8万', color: 'bg-primary-100 text-primary-700' },
  { id: 2, name: '国产科幻崛起', count: '9.6万', color: 'bg-accent-100 text-accent-700' },
  { id: 3, name: '韩剧必看清单', count: '8.3万', color: 'bg-secondary-100 text-secondary-700' },
  { id: 4, name: '动画电影精选', count: '7.1万', color: 'bg-primary-100 text-primary-700' },
  { id: 5, name: '悬疑烧脑推荐', count: '6.5万', color: 'bg-accent-100 text-accent-700' },
  { id: 6, name: '经典港片重温', count: '5.8万', color: 'bg-secondary-100 text-secondary-700' },
  { id: 7, name: 'Netflix高分剧', count: '5.2万', color: 'bg-primary-100 text-primary-700' },
  { id: 8, name: '纪录片推荐', count: '4.6万', color: 'bg-accent-100 text-accent-700' },
  { id: 9, name: '日漫新番追更', count: '4.1万', color: 'bg-secondary-100 text-secondary-700' },
];

export const mediaItems = [
  {
    id: 1,
    title: '《长安三万里2》终极预告',
    duration: '02:35',
    views: '156万',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20film%20Tang%20dynasty%20epic%20scene%2C%20warm%20golden%20lighting%2C%20ancient%20Chinese%20architecture%2C%20cinematic%20composition%2C%20rich%20cultural%20aesthetic%2C%20dramatic%20sky&width=640&height=360&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《流浪地球3》幕后特辑',
    duration: '08:12',
    views: '98万',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20space%20scene%20with%20massive%20spaceship%2C%20warm%20orange%20and%20gold%20nebula%20lighting%2C%20epic%20cinematic%20scale%2C%20dramatic%20composition%2C%20futuristic%20technology&width=640&height=360&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '韩剧《她的秘密》精彩片段',
    duration: '04:18',
    views: '132万',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20moment%20scene%2C%20warm%20intimate%20lighting%2C%20soft%20depth%20of%20field%2C%20emotional%20atmosphere%2C%20cinematic%20color%20grading%2C%20elegant%20composition&width=640&height=360&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《鬼灭之刃》最终季PV',
    duration: '01:45',
    views: '210万',
    image: 'https://readdy.ai/api/search-image?query=Anime%20action%20scene%20with%20dynamic%20sword%20combat%2C%20vibrant%20warm%20fire%20effects%2C%20Japanese%20animation%20style%2C%20dramatic%20lighting%2C%20epic%20composition%2C%20rich%20color%20contrast&width=640&height=360&seq=media-04&orientation=landscape',
  },
  {
    id: 5,
    title: 'BBC《蓝色星球3》震撼画面',
    duration: '05:30',
    views: '87万',
    image: 'https://readdy.ai/api/search-image?query=Underwater%20ocean%20documentary%20scene%20with%20sunlight%20rays%20through%20water%2C%20colorful%20coral%20reef%2C%20marine%20life%2C%20crystal%20clear%20blue%20water%2C%20cinematic%20nature%20photography%2C%20ethereal%20atmosphere&width=640&height=360&seq=media-05&orientation=landscape',
  },
];

export const aboutData = {
  title: '关于春色影视',
  description: '春色影视成立于2020年，是一个致力于为全球华人提供高清免费在线观影服务的影视平台。我们汇聚了海量电影、电视剧、动漫和纪录片资源，覆盖华语、日韩、欧美等多个地区的内容。\n\n平台采用先进的视频编码与CDN加速技术，确保用户在任意网络环境下都能获得流畅的高清观影体验。我们坚持完全免费的运营理念，通过技术优化降低运营成本，让更多人能够轻松享受优质影视内容。\n\n我们的编辑团队全天候追踪全球影视动态，第一时间更新最新资源。无论是院线新片、热播剧集还是经典老片，春色影视都力求为用户提供最全面的选择。',
  stats: [
    { value: '20,000+', label: '影视资源' },
    { value: '500万+', label: '月活用户' },
    { value: '99.9%', label: '播放成功率' },
    { value: '7×24', label: '内容更新' },
  ],
};

export const cardItems = [
  {
    id: 1,
    title: '《她和她的群岛》——女性群像剧的温情突围',
    category: '剧评',
    date: '2026-07-30',
    excerpt: '这部剧以细腻的笔触描绘了当代女性的生活图景，几位主演的表演真实动人...',
    image: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20drama%20scene%20with%20soft%20natural%20lighting%2C%20modern%20Chinese%20interior%2C%20emotional%20actress%20portrait%2C%20cinematic%20color%20grading%2C%20gentle%20atmosphere%2C%20storytelling%20vibe&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '2026上半年华语电影票房TOP10盘点',
    category: '盘点',
    date: '2026-07-28',
    excerpt: '今年上半年华语电影市场持续回暖，多部国产影片票房口碑双丰收，科幻与动画成最大赢家...',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20box%20office%20concept%20with%20warm%20golden%20lighting%2C%20movie%20tickets%20and%20popcorn%2C%20elegant%20theater%20interior%2C%20professional%20photography%20style%2C%20rich%20dark%20tones%20with%20warm%20accents&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '从《星际穿越2》看科幻电影的情感内核',
    category: '影评',
    date: '2026-07-26',
    excerpt: '诺兰式的硬科幻外壳下，藏着一颗关于爱与时间的柔软内核。续作延续了这一传统...',
    image: 'https://readdy.ai/api/search-image?query=Cosmic%20space%20scene%20with%20warm%20starlight%2C%20emotional%20astronaut%20silhouette%2C%20vast%20galaxy%20background%2C%20cinematic%20sci-fi%20aesthetic%2C%20deep%20contrast%20lighting%2C%20philosophical%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '韩剧如何持续征服全球观众',
    category: '观察',
    date: '2026-07-24',
    excerpt: '从制作水准到叙事创新，韩剧产业正在经历质的飞跃。Netflix等平台的全球化策略也功不可没...',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20production%20set%20with%20professional%20film%20crew%2C%20warm%20studio%20lighting%2C%20modern%20equipment%2C%20cinematic%20behind%20the%20scenes%2C%20elegant%20composition%2C%20creative%20atmosphere&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '暑期档亲子观影指南：适合全家一起看的好片',
    category: '指南',
    date: '2026-07-22',
    excerpt: '暑假带娃看什么？我们精选了10部适合亲子共同观看的优秀影片，兼顾趣味性与教育意义...',
    image: 'https://readdy.ai/api/search-image?query=Family%20watching%20movie%20together%20in%20cozy%20living%20room%2C%20warm%20ambient%20lighting%2C%20happy%20atmosphere%2C%20cinematic%20home%20theater%20vibe%2C%20soft%20decor%2C%20comfortable%20setting&width=600&height=400&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '国产动画电影的崛起之路',
    category: '专题',
    date: '2026-07-20',
    excerpt: '从《大圣归来》到《长安三万里》，国产动画电影在技术与叙事上实现了双重飞跃...',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20studio%20scene%2C%20warm%20creative%20workspace%2C%20character%20design%20sketches%20on%20wall%2C%20cinematic%20color%20palette%2C%20artistic%20atmosphere%2C%20modern%20cultural%20aesthetic&width=600&height=400&seq=card-06&orientation=landscape',
  },
  {
    id: 7,
    title: '纪录片推荐：五部改变你世界观的神作',
    category: '推荐',
    date: '2026-07-18',
    excerpt: '好的纪录片能打开一扇看世界的新窗。这五部精心挑选的纪录片，每一部都值得你花时间...',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20filmmaking%20scene%20with%20professional%20camera%20in%20nature%2C%20warm%20golden%20hour%20light%2C%20cinematic%20landscape%20background%2C%20adventure%20spirit%2C%20rich%20earthy%20tones%2C%20exploration%20vibe&width=600&height=400&seq=card-07&orientation=landscape',
  },
];

export const contactData = {
  title: '联系我们',
  description: '如果您有任何问题、建议或合作意向，欢迎通过以下方式与春色影视团队取得联系。我们重视每一位用户的反馈。',
  email: 'contact@chunseys.com',
  wechat: 'ChunseYS_Official',
  qq: '3141592653',
  workingHours: '周一至周日 9:00 - 22:00',
};

export const faqItems = [
  {
    id: 1,
    question: '春色影视真的完全免费吗？需要注册吗？',
    answer: '是的，春色影视所有内容完全免费观看，无需注册登录，没有隐藏收费，也没有会员等级。我们通过技术优化和广告合作来维持运营，让每一位用户都能零门槛享受高清影视内容。',
  },
  {
    id: 2,
    question: '为什么有些视频加载比较慢？如何解决？',
    answer: '视频加载速度主要受您的网络环境影响。如果遇到缓冲情况，可以尝试：1) 切换到较低画质；2) 关闭其他占用带宽的应用；3) 切换网络（如从WiFi切换到移动数据）。我们的CDN加速节点覆盖全国，大多数情况下都能保证流畅播放。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？可以投屏到电视吗？',
    answer: '春色影视支持电脑、平板、手机等所有主流设备。网页端采用响应式设计，自动适配不同屏幕尺寸。如果您想在大屏电视上观看，可以使用浏览器的投屏功能（如Chrome的Cast功能）或通过HDMI连接电脑与电视。',
  },
  {
    id: 4,
    question: '新片更新速度快吗？一般多久能上线？',
    answer: '我们的内容团队全天候工作，争取在影片上线后的24-48小时内完成更新。热播剧集和院线新片是重点跟进对象。您可以在首页的"更新快讯"板块查看最新上线的资源动态。',
  },
  {
    id: 5,
    question: '如何反馈问题或建议上架某部影片？',
    answer: '欢迎通过"联系我们"板块提供的邮箱或微信公众号与我们联系。如果您想看的影片暂时没有，也欢迎告知我们，内容团队会评估后优先安排上架。您的每一条反馈都是我们改进的动力。',
  },
];